module.exports = __webpack_public_path__ + "img/PM_A01_back_en.61e2b1ff.png";